<script lang="ts">
  import { uniqueId } from "@/Util/utils";

  export let label: string = "";
  // export let value: string = "";
  // export let input = null;
  // export let output = null;
  export let isChecked: boolean = true;
  // export let hidden = false;
  let className = ""
  export {className as class}

  const id = uniqueId('toggle-');
  
</script>


<div class="toggle-wrapper {className}">
    <input type="checkbox" {id} bind:checked={isChecked} on:change />
    <label for={id}/>
    <span class='ml-[12px]'>{label}</span>
</div>

<style>
  input[type="checkbox"] {
    visibility: visible;
  }
  label.mt-checkbox {
    display: inline;
    vertical-align: middle;
    white-space: nowrap;
    margin-right: 16px;
    max-height: 90%;
    margin:5%;
  }
</style>
